import { Fragment } from 'react';
import { t } from '../i18n';
import { useConfig } from '../lib/config';
import { isBilltoro } from '../produkt';

// Impressum und Datenschutzerklärung (DSGVO Art. 13, § 5 DDG): unten auf den Seiten ohne Anmeldung und im
// Konto-Menü von Mandanten-App und Kanzlei. Die Adressen kommen aus IMPRESSUM_URL und DATENSCHUTZ_URL (in der
// Produktion immer gesetzt). menu: als Einträge im Konto-Menü. mitAgb: bei Billtoro auch die AGB (Anmeldung,
// Rechnungswerkzeug), nicht auf der Seite für die Kunden der Firma.
export function LegalLinks({ menu, mitAgb }: { menu?: boolean; mitAgb?: boolean }) {
  const { impressumUrl, datenschutzUrl, agbUrl } = useConfig();
  const agb = mitAgb && isBilltoro() ? agbUrl : null;
  const links = [
    impressumUrl ? { href: impressumUrl, label: t('Impressum') } : null,
    datenschutzUrl ? { href: datenschutzUrl, label: t('Datenschutz') } : null,
    agb ? { href: agb, label: 'AGB' } : null,
  ].filter((l) => l !== null);
  if (!links.length) return null;
  if (menu) {
    return (
      <span className="legal-menu">
        {links.map((l) => (
          <a key={l.href} role="menuitem" href={l.href} target="_blank" rel="noopener noreferrer">
            {l.label}
          </a>
        ))}
      </span>
    );
  }
  return (
    <nav className="legal" aria-label={t('Rechtliches')}>
      {links.map((l, i) => (
        <Fragment key={l.href}>
          {i > 0 && ' · '}
          <a href={l.href} target="_blank" rel="noopener noreferrer">
            {l.label}
          </a>
        </Fragment>
      ))}
    </nav>
  );
}
